import { useSimpleTranslation } from "@ldp/simple-i18n";
import { useMemo } from "react";
/**
 * Hook to render accessibility cart messages
 */
export const useGetA11yCartMessages = () => {
  const i18n = useSimpleTranslation();
  return useMemo(() => {
    return {
      a11yATCMessage: i18n("a11yAddToCart"),
      a11yDecreaseQtyMessage: i18n("a11yDecreaseQuantity"),
      a11yIncreaseQtyMessage: i18n("a11yIncreaseQuantity"),
      a11yItemInCartMessage: i18n("a11yEditQuantity"),
      a11yVariantItemInCartMessage: i18n("a11yViewProductDetails"),
      a11yLiveQuantityMessage: i18n("a11yQuantityInCart"),
      a11yAriaLabelInput: i18n("a11yQuantityInCartLabel"),
      a11yLiveMaxQuantityMessage: i18n("a11yQuantityLimitReached"),
      a11yAriaLabelRating: i18n("a11yStarRatingLabel"),
    };
  }, [i18n]);
};

export default useGetA11yCartMessages;
